import { type PortableTextBlock } from '@portabletext/types';
import { useSecureGraphqlQuery } from '@psyomics/ui-common';
import { ContentArticle as ContentArticleMolecule, GenericError, LoadingSpinner } from '@psyomics/ui-components';
import { AnyVariables } from 'urql';

import { ArticleByIdDocument, ArticleByIdQuery } from '../generated/content';

import { mapArticleByIdToArticle } from './content-article.mapper';

type Article = {
  body: PortableTextBlock[];
  id: string;
  image: string | null;
  title: string;
};

const useArticle = (id: string): { article: Article | null; fetching: boolean; errorMessage?: 'ContentNotFound' } => {
  const [{ data, fetching, errorMessage }] = useSecureGraphqlQuery<ArticleByIdQuery, AnyVariables, 'ContentNotFound'>(
    {
      pause: !id,
      query: ArticleByIdDocument,
      variables: {
        id,
      },
    },
    ['ContentNotFound']
  );

  const article = mapArticleByIdToArticle(data?.articleById);

  return { article, fetching, errorMessage };
};

type ContentArticleProps = {
  readonly id: string;
};
const ContentArticle = ({ id }: ContentArticleProps) => {
  const { article, fetching, errorMessage } = useArticle(id);

  if (fetching) return <LoadingSpinner />;
  if (errorMessage === 'ContentNotFound') return <GenericError titleKey="page.healthLibrary.errors.notFound" />;
  if (!article) return null;

  return <ContentArticleMolecule article={article} />;
};

export type { Article };
export { ContentArticle };
